import flatpickr from "flatpickr";
import { english } from "flatpickr/dist/l10n/default.js";
import { Lithuanian } from "flatpickr/dist/l10n/lt.js";
import { Russian } from "flatpickr/dist/l10n/ru.js"

export default function initDatepicker() {
    for (const picker of document.querySelectorAll('.datepicker')) {
        flatpickr(picker, {
            minDate: "today",
            locale: getLocale(),
            dateFormat: "Y-m-d",
            disableMobile: true,
        });
    }
}

function getLocale () {
    switch (document.documentElement.lang.split('-')[0]) {
        case 'lt':
            return Lithuanian;
        case 'en':
            return english;
        case 'ru':
            return Russian;
        default:
            return Lithuanian;
    }
}
